// Toggle visibilit of mobile menu on hamburger button click

const toggleMenuVisiblity = document.querySelector("[data-action='toggle-menu-visiblity']");

toggleMenuVisiblity.addEventListener("click", function () {
    let element = this;

    const html = document.querySelector("html");

    const active = element.closest(".active");
    if (active) {
        html.style.overflowY = 'auto';
    } else {
        html.style.overflowY = 'hidden';
    }

    // Toggle class active for button
    element.classList.toggle("active");

    html.classList.toggle("show-menu");

    return false;
});

const link = document.querySelectorAll(".header-nav__link.dropdown-toggle");
if (link) {

    link.forEach(item => {
        item.addEventListener("click", function (event) {
            let href = item.dataset.href;
            if (window.innerWidth > 1200) {
                window.open(href, '_self');
            } else {
                event.preventDefault()
            }
        });

        // Hide pined menu when mouseenter on link menu
        item.addEventListener("mouseenter", function (event) {
          const dropdown_menu = document.querySelectorAll('.dropdown-menu.pinned');

          if (dropdown_menu) {
            dropdown_menu.forEach(menu => {
              menu.classList.remove('pinned');
            });
          }

        });
    });
}

// Show/Hide submenu
const submenu = document.querySelectorAll("[data-action='submenu']");
if (submenu) {

  submenu.forEach(item => {
        item.addEventListener("click", function (event) {
            event.stopPropagation();
            
            const id = item.dataset.id;
            const is_active = item.dataset.active;
            const dropdown_menu = item.closest('.dropdown-menu');

            const content = document.querySelector("[data-action='submenu-content'][data-id='"+id+"']");

            let activeElemnets = document.querySelectorAll(`[data-action='submenu-content'][data-active='true']`);
    
            // remove class and attributes if found active elements
            if (activeElemnets.length > 0) {
                activeElemnets.forEach(activeElemnet => {
                    activeElemnet.setAttribute("data-active", "false");
                    activeElemnet.classList.remove("active");
                });
            }

            if (is_active == 'false') {
              content.classList.add('active');
              item.setAttribute("data-active", "true");
              content.setAttribute("data-active", "true");
              dropdown_menu.classList.add('pinned');
            } else {
              content.classList.remove('active');
              item.setAttribute("data-active", "false");
              content.setAttribute("data-active", "false");
              dropdown_menu.classList.remove('pinned');
            }

        });
    });
}

document.addEventListener("click", function (event) {
  const dropdown_menu = document.querySelectorAll('.dropdown-menu.pinned');

  if (dropdown_menu) {
    dropdown_menu.forEach(menu => {
      menu.classList.remove('pinned');
    });
  }
});

$('.dropdown').on('show.bs.dropdown', function () {
    $(this).find('.dropdown-menu').first().stop(true, true).slideDown();
});

// Add slideUp animation to Bootstrap dropdown when collapsing.
$('.dropdown').on('hide.bs.dropdown', function () {
    $(this).find('.dropdown-menu').first().stop(true, true).slideUp();
  });

  // scroll to section
  $("a.scroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {

      // Store hash
      var hash = this.hash;

      let element = $(hash);
      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      if (element.length > 0) {
        $('html, body').animate({
            scrollTop: $(hash).offset().top - 50
          }, 800, function(){
    
            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          });
      } else { 
        window.location.href = "/" + hash;
      }
      
    } // End if
  });

//   window.addEventListener('load', () => {
//     /* Scroll if hash */
//     if(window.location.hash) {
//       // Store hash
//       var hash = window.location.hash;

//       let element = $(hash);
//       let offset = -50;

//       if (hash == '#offer') {
//         offset = 150;
//       }
//       // Using jQuery's animate() method to add smooth page scroll
//       // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
//       if (element.length > 0) {
//         setTimeout(() => {
//           console.log('1');
//         $('html, body').animate({
//             scrollTop: $(hash).offset().top + offset
//           }, 800, function(){
    
//             // Add hash (#) to URL when done scrolling (default click behavior)
//             window.location.hash = hash;
//           });
//         },300);
//       } else {
//         window.location.hash = hash;
//       }
     

//     }
// });